import { pipe } from 'fp-ts/function';
export var borderRadius = function borderRadius(theme) {
  return pipe(theme.shape.borderRadius, function (x) {
    return typeof x === 'number' ? "".concat(x, "px") : x;
  });
};